import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../models/ApiResponse';
import { GeneralRequestModel } from '../models/generalRequestModel';

@Injectable({
  providedIn: 'root'
})
export abstract class SearchService<T> {
  abstract search(
    searchTerm: string,
    userId: string | null,
    pagination: GeneralRequestModel
  ): Observable<ApiResponse<T>>;
}
